import axios from "axios";
import { api } from "@/plugins/util";
import qs from "qs";


export function finenceList( {companyName,socialCreditUnicode,type,productName,serviceBank,pageNum},status ) {
    return axios.post(api + "/finance/list", qs.stringify({
            companyName,
            socialCreditUnicode,
            type,
            productName,
            serviceBank,
            pageNum,
            status
        })
    );
}
export function getRefusalOfLoanByFinanceId(financeId) {
    return axios.get(api + "/finance/getRefusalOfLoanByFinanceId",{
        params:{
            financeId
        }
    })
}

/**
 * 根据状态导出订单
 * @param data
 * @returns {AxiosPromise<any>}
 */
export function exportOrderByStatus(data) {
    return axios.post(api + "/finance/exportOrderByStatus", data,{ responseType:'blob'});
}
